export const TICKET_DETAILS = 'TICKET_DETAILS';
export const ticketDetails = q => ({
  type: TICKET_DETAILS,
  payload: q
});
